import { render, staticRenderFns } from "./producttariff.vue?vue&type=template&id=bfb30a68&"
import script from "./producttariff.vue?vue&type=script&lang=js&"
export * from "./producttariff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports